import React, {Component} from 'react'
import {ContactStyle, Form, FaqPopinStyle} from './../styles'
import {addFaqQuestion} from './../services/ApiController'
import {Field, Button, Success, Error} from './'
import { closeModal} from './../store/actions/FaqModal'
import { withLoader } from '../hoc/withLoader';

import {connect} from 'react-redux'

class FaqPopin extends Component {
  state = {
    ready: true,
    error: '',
    fields: {
      question: {
        label: 'Your question',
        type: 'text',
        id: 'question_question',
        value: '',
        name: 'question[question]'
      }
    },
    action: '/question',
    form: {}
  }

  componentWillReceiveProps({ data }) {
    const row = []
    row[data.fields['_token'].name] = data.fields['_token'].value
    this.setState({ form: row })
  }

  handleOverlay = (e) => {
    if (e.target.closest('.popin-inner') === null) {
      this.props.closeModal()
    }
  }

  handlerSubmit = async () => {
    this.setState({
      error: ''
    }, () => {
      if (this.check().valid ) {
        addFaqQuestion(this.state.action, this.state.form).then((data) => {
          if (data.success) { 
            this.setState({ form: {}, clean: true})
            this.setState({ success: 'Thank you for your question.', success2: 'We will examine it shortly.'})
          }
        }).then(() => {
          this.setState({ clean: false })
        }).catch((e) => {
          console.log('Something wrong with postMessage')
        })
      } else {
        this.setState({
          error: this.check().err
        })
      }
    })
  }

  addFormData = (data) => {
    const { form } = this.state
    const row = []
    row[data.key] = data.value
    this.setState({ form: { ...form, ...row} })
  }

  check = () => {
    let valid = true
    let err = ''
    
    if (!this.state.form['question[question]']) {
      err = 'Field question is required'
      valid = false
    }
    
    return {valid, err}
  }

  render() {
    const { fields, success, success2, error } = this.state

    return (
      <div className={`${FaqPopinStyle()} ${this.props.isOpen ? 'is-open' : ''}`} onClick={(e) => this.handleOverlay(e)}>
        <div className={`contact popin-inner ${ContactStyle(true)}`}>
          <button className='popin-close' onClick={() => this.props.closeModal()}>
            <svg className="shape" viewBox="0 0 24 24" width="24" height="24">
              <path d="M5.97786163,5.59528375 C6.37110859,5.20203679 6.99946072,5.20266928 7.38740665,5.5906152 L7.38740665,5.5906152 L12.3416453,10.5450002 L17.2962387,5.5906152 C17.6841846,5.20266928 18.3125367,5.20203679 18.7057837,5.59528375 C19.096308,5.98580804 19.0982659,6.61701507 18.7104522,7.00482877 L13.7556453,11.9590002 L18.7104522,16.9136608 C19.0684341,17.2716427 19.0943029,17.8370129 18.7890065,18.2290327 L18.7057837,18.3232058 L18.6110774,18.4069662 C18.2172897,18.7140637 17.6543426,18.6859783 17.2962387,18.3278744 L17.2962387,18.3278744 L12.3416453,13.3730002 L7.38740665,18.3278744 C7.02930272,18.6859783 6.46635562,18.7140637 6.07256796,18.4069662 L5.97786163,18.3232058 C5.58733734,17.9326815 5.58537939,17.3014745 5.97319309,16.9136608 L10.9276453,11.9590002 L5.97319309,7.00482877 C5.61521121,6.64684689 5.58934246,6.08147662 5.89463882,5.68945688 Z" id="path-1"></path>
            </svg>
          </button>

          <form className={`contact-form ${Form}`} onSubmit={this.handlerSubmit}>
              <p className='contact-title-faq'>You have a question ?<br/>Submit it</p>
              {
                Object.keys(fields).map((field, index) => (
                  <Field onChange={this.addFormData} {...fields[field]} key={field}> {fields[field].label} </Field>
                ))
              }
              
              <div className="contact-btn-submit">
                <Button theme="red" type="submit" onCallback={this.handlerSubmit}> Send </Button>
              </div>
              {
                error !== '' && (
                  <Error className="error"> {error} </Error>
                )
              }
              {
                error === '' && success && (
                  <Success className="success"> {success}<br/>{success2}</Success>
                )
              }
            </form>
        </div>
      </div>
    )
  }
}

export default withLoader(connect(
  ({FaqModal}) => ({
    isOpen: FaqModal.isOpen
  }),
  dispatch => ({
    closeModal: () => dispatch(closeModal())
  })
)(FaqPopin), '/question')


// WEBPACK FOOTER //
// ./src/components/FaqPopin.js